import { Autocomplete, Box, Button, Dialog, FormControlLabel, IconButton, Radio, RadioGroup, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CommonPatientDetails, ConfirmPopup } from '../../../Components/Common Components/CommonComponents'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CloseIcon from '@mui/icons-material/Close';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { clearCachevalue, setCachevalue } from '../../../Utility/Services/CacheProviderService';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { DateTime } from 'luxon';
import { ImagePaths } from '../../../Utility/ImagePaths';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DataGrid } from '@mui/x-data-grid';
import { formatDateTime, renderCorpInsuranceCard } from '../../../Components/CommonFunctions/CommonFunctions';

const topLayoutStates = {
    openAddendumPopup: false,
    addendum_notes: '',
    isLocked: false,
    openTransferPopup: false,
    selectedRadio: 'doctor',
    doctorMandatory: false,
    PurposeOfVisit: '',
    comments: '',
    loginUserInfo: {},
    selectedSpecialization: null,
    specializationList: [],
    doctorList: [],
    selectedDoctor: null,
    specialListApp: [],
    selectedSpecialListApp: null,
    dupDoctorList: '[]',
    dupSpecialListApp: '[]',
    selectedDoctorApp: null,
    optometristList: [],
    selectedOpto: null,
    recallPopup: false,
    recallNotes: '',
    notesPopup: false,
    notesData: [],
    notesPage: 0,
    notesPageSize: 10,
    completePop: false,
    patientPrimType: {},
}

const UmaDocTopLayout = React.forwardRef((props, ref) => {
    const [layout, setLayout] = useState(topLayoutStates)
    const history = useHistory()
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    const completeStatus = () => {
        postStatusUpdate('Completed')
    }

    useEffect(() => {
        if (props.patientData.clinic_id && props.patientData.loginUserInfo && props?.patientData?.doctorID) {
            getDoctorListData()
            getSpecilizationList()
            getOptomestristData()
            getPatientPrimaryData()
        }
    }, [props.patientData.clinic_id, props.patientData.loginUserInfo, props.patientData.doctorID])

    const getDoctorPatientAppointment = async () => {
        try {
            let response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_APPOINTMENT_DETAILS
                + '?clinic_id=' + props?.patientData?.clinic_id + '&appointment_id=' + props?.patientData?.appointment_id
            )
            if (response.data.status === 'success') {
                let lock = response.data.data?.is_locked ? true : false
                setLayout((prev) => ({ ...prev, isLocked: lock }))
                props?.lockDocNotes(lock)
                setCachevalue(JSON.stringify(response?.data?.data), 'DoctorPatientData')
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getDoctorListData = async () => {
        try {
            let response = await RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?clinic_id=${props?.patientData?.clinic_id}`)
            if (response?.data?.status === 'success') {
                let responseData = response?.data?.data?.length > 0 ? response?.data?.data : []
                let activeDoc = responseData.filter((item) => item.is_active === true)
                setLayout((prev) => ({
                    ...prev,
                    doctorList: activeDoc,
                    dupDoctorList: JSON.stringify(activeDoc)
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getSpecilizationList = async () => {
        try {
            let response = await RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION + '?clinic_id=' + props?.patientData?.clinic_id)
            if (response?.data?.status === 'success') {
                let responseData = response?.data?.data?.length > 0 ? response?.data?.data : []
                let activeItems = responseData.filter((item) => item.is_active === true);
                let doctorSpecialList = activeItems?.filter(item => item.id === props.patientData?.loginUserInfo?.specialization_id)
                setLayout((prev) => ({
                    ...prev,
                    specializationList: doctorSpecialList,
                    selectedSpecialization: doctorSpecialList[0],
                    specialListApp: activeItems,
                    dupSpecialListApp: JSON.stringify(activeItems)
                }));
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getOptomestristData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.GET_OPTOMETRIST_NAME_LIST + '?doctor_id=' + props?.patientData?.doctorID)
            if (response?.data?.status === 'success') {
                setLayout((prev) => ({
                    ...prev,
                    optometristList: response?.data?.data,
                    selectedOpto: response.data.data[0]
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getPatientPrimaryData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_PRIMARY_PAYMENT_GET + '?appointment_id=' + props?.patientData?.appointment_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setLayout((prev) => ({
                            ...prev,
                            patientPrimType: response?.data?.data
                        }))
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const RecallNotesPost = (status) => {
        try {
            let data = {
                "clinic_id": props?.patientData?.clinic_id,
                "appointment_id": props?.patientData?.appointment_id,
                "patient_id": props?.patientData?.patient_id,
                "recall_status": status
            }
            if (status === "pending") {
                data["recall_notes"] = layout.recallNotes;
                data["recall_optometrist_id"] = layout.selectedOpto?.optometrist_id;
            }
            RestAPIService.create(data, Serviceurls.DOC_RECALL_NOTES_POST)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        successMessage(response.data.message)
                        setLayout((prev) => ({
                            ...prev,
                            recallPopup: false
                        }))
                        props.callPatientDetails(true)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    const postTransferRequestData = async () => {
        try {
            let data = {
                appointment_id: props.patientData?.appointment_id,
                clinic_id: +props.patientData?.clinic_id,
                doctor_id: layout.selectedDoctor?.doctor_id,
                patient_id: props.patientData?.patient_id,
                transfer_notes: layout?.comments
            }
            const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_TRANSFER)
            if (response?.data?.status === 'success') {
                successMessage(response?.data?.message)
                setTimeout(() => {
                    clearCachevalue("DoctorPatientData")
                    history.push({ pathname: "/DoctorHome" })
                }, 500)
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const postAppointmentRequestData = async () => {
        try {
            let startDate = new Date()
            let AppDate = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
            let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let data = {
                patient_id: props?.patientData?.patient_id,
                doctor_id: layout?.selectedDoctorApp?.doctor_id,
                speciality_id: layout?.selectedSpecialListApp?.id,
                purpose_of_visit: layout?.PurposeOfVisit,
                appointment_date: AppDate,
                appointment_start_time: Aptime,
                patient_appointment_type: 3,
                nurse_id: null,
                request_id: null,
                clinic_id: +props?.patientData?.clinic_id,
                new_appointment: true
            }
            const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_APPOINTMENT_CREATE)
            if (response?.data?.status === 'success') {
                successMessage(response?.data?.message)
                postStatusUpdate()
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }
    // Old Addendum API POST ========>
    // const postAddendumData = async () => {
    //     try {
    //         let list = { addendum_notes: layout.addendum_notes }
    //         let response = await RestAPIService.create(list, Serviceurls.NEW_DOC_NOTES_LOCK + `${props?.patientData?.appointment_id}/lock/`)
    //         if (response.data.status === 'success') {
    //             successMessage(response.data.message)
    //             await getDoctorPatientAppointment()
    //         }
    //     } catch (error) {
    //         if (error?.response?.data?.message) {
    //             errorMessage(error.response.data.message)
    //         } else {
    //             errorMessage(error.message)
    //         }
    //     }
    // }

    const getAddendumNotes = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.GET_ADDENDUM_LOG + '?appointment_id=' + props?.patientData?.appointment_id)
            if (response?.data?.status === 'success') {
                setLayout((prev) => ({
                    ...prev,
                    notesData: response?.data?.data
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const postAddendumData = async () => {
        try {
            let data = {
                addendum_notes: layout.addendum_notes,
                appointment_id: props.patientData?.appointment_id
            }
            let response = await RestAPIService.create(data, Serviceurls.GET_ADDENDUM_LOG)
            if (response.data.status === 'success') {
                successMessage(response.data.message)
                setLayout((prev) => ({ ...prev, openAddendumPopup: false, addendum_notes: '' }))
                await getAddendumNotes()
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const postStatusUpdate = async (status) => {
        try {
            let list = {}
            switch (status) {
                case 'Scan/Surgery':
                    list = {
                        appointment_id: props?.patientData?.appointment_id,
                        appointment_status: status,
                        clinic_id: props?.patientData?.clinic_id,
                        waiting_timer: null
                    }
                    break;
                case 'Completed':
                    list = {
                        appointment_id: props?.patientData?.appointment_id,
                        appointment_status: status,
                        clinic_id: props?.patientData?.clinic_id,
                        waiting_timer: null
                    }
                    break;
                default:
                    list = {
                        appointment_id: props?.patientData?.appointment_id,
                        appointment_status: "Completed",
                        waiting_timer: null,
                        is_transfered: true,
                        transfer_doctor_id: layout?.selectedDoctorApp?.doctor_id,
                        transfer_id: null,
                        clinic_id: +props?.patientData?.clinic_id,
                    }
                    break;
            }
            let response = await RestAPIService.create(list, Serviceurls.NEW_DOC_NOTES_APPOINTMENT_STATUS)
            if (response.data.status === 'success') {
                successMessage(response.data.message)
                setTimeout(() => {
                    clearCachevalue('updatePatient')
                    history.push({ pathname: "/DoctorHome" })
                }, 500)
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const postLockDoctorNotes = async () => {
        try {
            let list = {
                appointment_id: props?.patientData?.appointment_id,
                status: 'appointment lock'
            }
            let response = await RestAPIService.create(list, Serviceurls.NEW_DOC_NOTES_LOCK + `${props?.patientData?.appointment_id}/lock/`)
            if (response.data.status === 'success') {
                successMessage(response.data.message)
                await getDoctorPatientAppointment()
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const renderTransferPopupScreen = () => {
        try {
            return (
                <Dialog open={layout.openTransferPopup} maxWidth="sm" fullWidth>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography className='doc_notes_header_card_font'>Transfer</Typography>
                            <IconButton
                                onClick={() => setLayout((prev) => ({
                                    ...prev,
                                    openTransferPopup: false,
                                    selectedRadio: 'doctor',
                                    doctorMandatory: false,
                                    PurposeOfVisit: '',
                                    comments: '',
                                    selectedSpecialization: null,
                                    specializationList: [],
                                    doctorList: [],
                                    selectedDoctor: null,
                                    specialListApp: [],
                                    selectedSpecialListApp: null,
                                    dupDoctorList: '[]',
                                    dupSpecialListApp: '[]',
                                    selectedDoctorApp: null
                                }))}><CloseIcon /></IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Box component={'div'} display={'flex'} justifyContent={'flex-end'}>
                                <RadioGroup
                                    row
                                    value={layout.selectedRadio}
                                    onChange={(e) => {
                                        setLayout((prev) => ({
                                            ...prev,
                                            selectedRadio: e.target.value,
                                            PurposeOfVisit: '',
                                            selectedDoctor: null,
                                            selectedDoctorApp: null,
                                            selectedSpecialListApp: null,
                                            specialListApp: JSON.parse(layout.dupSpecialListApp),
                                            doctorList: JSON.parse(layout.dupDoctorList),
                                            comments: ''
                                        }))
                                    }}
                                >
                                    <FormControlLabel value="doctor" control={<Radio size='small' />} label={<Typography className='doc_notes_header_card_font'>Transfer Doctor</Typography>} />
                                    <FormControlLabel value="appointment" control={<Radio size='small' />} label={<Typography className='doc_notes_header_card_font'>Transfer Appointment</Typography>} />
                                </RadioGroup>
                            </Box>
                            <Box component={'div'}>
                                {layout.selectedRadio === 'doctor' ?
                                    <Box component={'div'} display={'flex'}>
                                        <Autocomplete
                                            clearIcon
                                            size='small'
                                            sx={{ width: "18vw", mr: '1rem' }}
                                            options={layout.specializationList}
                                            getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.name}
                                            value={layout?.selectedSpecialization}
                                            onChange={(e, newValue) => { setLayout((prev) => ({ ...prev, selectedSpecialization: newValue })) }}
                                            renderInput={(params) => <TextField {...params} label='Specialization *' />}
                                        />
                                        <Autocomplete
                                            clearIcon
                                            size='small'
                                            sx={{ width: "18vw" }}
                                            options={layout.doctorList}
                                            getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.doctor_name}
                                            value={layout?.selectedDoctor}
                                            onChange={(e, newValue) => { setLayout((prev) => ({ ...prev, selectedDoctor: newValue })) }}
                                            renderInput={(params) => <TextField {...params} label={layout.doctorMandatory ? 'Doctor *' : 'Doctor'} />}
                                        />
                                    </Box> :
                                    <Box component={'div'}>
                                        <Box component={'div'} display={'flex'} mb={'1rem'}>
                                            <Autocomplete
                                                clearIcon
                                                size='small'
                                                sx={{ width: "18vw", mr: '1rem' }}
                                                options={layout.specialListApp}
                                                getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.name}
                                                value={layout?.selectedSpecialListApp}
                                                onChange={(e, newValue) => {
                                                    let dupDoctorList = JSON.parse(layout.dupDoctorList)
                                                    setLayout((prev) => ({
                                                        ...prev,
                                                        selectedSpecialListApp: newValue,
                                                        doctorList: newValue ? dupDoctorList.filter(item => item.specialization_id === newValue?.id) : dupDoctorList,
                                                        selectedDoctorApp: null
                                                    }))
                                                }}
                                                renderInput={(params) => <TextField {...params} label='Specialization *' />}
                                            />
                                            <Autocomplete
                                                clearIcon
                                                size='small'
                                                sx={{ width: "18vw" }}
                                                options={layout.doctorList}
                                                getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.doctor_name}
                                                value={layout?.selectedDoctorApp}
                                                onChange={(e, newValue) => {
                                                    let dupSpecialList = JSON.parse(layout.dupSpecialListApp)
                                                    setLayout((prev) => ({
                                                        ...prev,
                                                        selectedDoctorApp: newValue,
                                                        selectedSpecialListApp: newValue ? dupSpecialList.find(item => item.id === newValue.specialization_id) : null,
                                                    }))
                                                }}
                                                renderInput={(params) => <TextField {...params} label={layout.doctorMandatory ? 'Doctor *' : 'Doctor'} />}
                                            />
                                        </Box>
                                        <Box component={'div'}>
                                            <Autocomplete
                                                inputProps={{ maxLength: 90 }}
                                                options={props.patientData?.POVList || []}
                                                getOptionLabel={(options) => options}
                                                onChange={(e, value) => {
                                                    setLayout((prev) => ({ ...prev, PurposeOfVisit: value }))
                                                }}
                                                clearIcon={false}
                                                size='small'
                                                sx={{ width: "37vw" }}
                                                value={layout.PurposeOfVisit}
                                                renderInput={(params) => <TextField {...params} placeholder="Purpose Of Visit *" />}
                                            />
                                        </Box>
                                    </Box>
                                }
                                <Box component={'div'} m={'0.5rem 0rem'}>
                                    <Typography m={'0.5rem 0rem'} fontSize={'0.9rem'} fontWeight={600}>Notes</Typography>
                                    <TextField
                                        label={("Enter Notes")}
                                        sx={{ width: '37dvw' }}
                                        multiline
                                        rows={4}
                                        variant="outlined"
                                        value={layout.comments}
                                        onChange={(event) => {
                                            let value = event.target.value
                                            if (value?.length <= 250) {
                                                setLayout((prev) => ({ ...prev, comments: value }))
                                            } else {
                                                errorMessage('Allowed only 250 characters')
                                            }
                                        }}
                                    />
                                </Box>
                                <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mt={'0.5rem'}>
                                    <Button variant='outlined' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '0.5rem' }}
                                        onClick={() => setLayout((prev) => ({ ...prev, openTransferPopup: false, comments: '' }))}
                                    >Cancel</Button>
                                    {layout.selectedRadio === 'doctor' ?
                                        <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '0.5rem' }}
                                            onClick={() => postTransferRequestData()}
                                        >Transfer</Button> :
                                        <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '0.5rem' }}
                                            onClick={() => postAppointmentRequestData()}
                                        >Create Appointment</Button>}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderAddendumPopupScreen = () => {
        try {
            return (
                <Dialog open={layout.openAddendumPopup} maxWidth="sm" fullWidth>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography className='doc_notes_header_card_font'>Reason for Addendum</Typography>
                                <IconButton
                                    onClick={() => {
                                        setLayout((prev) => {
                                            getAddendumNotes()
                                            return { ...prev, notesPopup: true }
                                        })
                                    }}
                                ><VisibilityIcon color='primary' /></IconButton>
                            </Box>
                            <IconButton
                                onClick={() => setLayout((prev) => ({ ...prev, openAddendumPopup: false, addendum_notes: '' }))}
                            ><CloseIcon /></IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <TextField
                                fullWidth
                                multiline
                                rows={5}
                                size='small'
                                value={layout.addendum_notes}
                                onChange={(e) => {
                                    let value = e.target.value
                                    setLayout((prev) => ({ ...prev, addendum_notes: value }))
                                }}
                                placeholder='Reason for Addendum'
                            />
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mb={'0.5rem'}>
                            <Button variant='outlined' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '0.5rem' }}
                                onClick={() => setLayout((prev) => ({ ...prev, openAddendumPopup: false, addendum_notes: '' }))}
                            >Cancel</Button>
                            <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '0.5rem' }}
                                onClick={postAddendumData}
                            >Addendum</Button>
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderAddendumNotesPopupScreen = () => {
        try {
            layout.notesData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                { field: 'sno', headerName: 'S.No', flex: 0.05 },
                {
                    field: 'created_by', headerName: 'Created By', flex: 0.25,
                    renderCell: (params) => {
                        let createdBy = params?.row?.created_by
                        return (
                            <Box>{createdBy ? createdBy?.length > 20 ?
                                <Tooltip placement='top' title={createdBy}><Typography>{createdBy?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                <Typography>{createdBy}</Typography> : '-'}</Box>
                        )
                    }
                },
                {
                    field: 'created_date', headerName: 'Created Date & Time', flex: 0.25,
                    renderCell: (params) => {
                        let createdDate = formatDateTime(params?.row?.created_date)
                        return (
                            <Box>{createdDate ? createdDate?.length > 20 ?
                                <Tooltip placement='top' title={createdDate}><Typography>{createdDate?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                <Typography>{createdDate}</Typography> : '-'}</Box>
                        )
                    }
                },
                {
                    field: 'notes', headerName: 'Notes', flex: 0.45,
                    renderCell: (params) => {
                        let notes = params?.row?.notes
                        return (
                            <Box>{notes ? notes?.length > 40 ?
                                <Tooltip placement='top' title={notes}><Typography>{notes?.slice(0, 40) + '...'}</Typography></Tooltip> :
                                <Typography>{notes}</Typography> : '-'}</Box>
                        )
                    }
                },
            ]
            return (
                <Dialog open={layout.notesPopup} fullWidth maxWidth='md'>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography className='doc_notes_header_card_font'>Addendum Notes</Typography>
                            <IconButton
                                onClick={() => setLayout((prev) => ({ ...prev, notesPopup: false }))}
                            ><CloseIcon /></IconButton>
                        </Box>
                    </Box>
                    <Box component={'div'} height={'60dvh'} p={'0.5rem'}>
                        <DataGrid
                            rows={layout.notesData}
                            page={layout.notesPage}
                            columns={columns}
                            hideFooterSelectedRowCount
                            getRowId={(row) => row.sno}
                            pageSize={layout.notesPageSize}
                            onPageChange={(newPage) => { setLayout((prev) => ({ ...prev, notesPage: newPage })) }}
                            onPageSizeChange={(newPageSize) => setLayout((prev) => ({ ...prev, notesPageSize: newPageSize }))}
                            rowsPerPageOptions={[10, 20, 30]}
                            loading={layout.isLoader}
                            localeText={{
                                toolbarColumns: "",
                                toolbarDensity: "",
                                toolbarExport: "",
                                toolbarFilters: "",
                                toolbarExportPrint: ""
                            }}
                            components={{
                                // Toolbar: CommonGridHeader.CommonToolBar,
                                // Toolbar: this.gridToolBar,
                                NoRowsOverlay: () => (
                                    <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        {'No Records To Be Shown'}
                                    </Box>
                                )
                            }}
                            headerHeight={40}
                        />
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderRecallPopup = () => {
        try {
            return (
                <Dialog open={layout.recallPopup} maxWidth="xs" fullWidth>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography className='doc_notes_header_card_font'>Recall</Typography>
                            <IconButton
                                onClick={() => setLayout((prev) => ({ ...prev, recallPopup: false, addendum_notes: '' }))}
                            ><CloseIcon /></IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Autocomplete
                                size='small'
                                options={layout.optometristList}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.optometrist_name}
                                onChange={(e, newValue) => {
                                    setLayout((prev) => ({
                                        ...prev,
                                        selectedOpto: newValue
                                    }))
                                }}
                                value={layout.selectedOpto}
                                renderInput={(params) => <TextField
                                    {...params}
                                    InputProps={{
                                        ...params.InputProps,
                                        emed_tid: 'rec_opt'
                                    }}
                                    label='Select Opthometrist'
                                />}
                            />
                            <Box component={'div'} mt={'1rem'}>
                                <TextField
                                    label={"Enter Notes Here"}
                                    fullWidth
                                    multiline={true}
                                    rows={4}
                                    variant="outlined"
                                    value={layout.recallNotes}
                                    onChange={(event) => {
                                        let value = event.target.value
                                        if (value?.length <= 500) {
                                            setLayout((prev) => ({ ...prev, recallNotes: value }))
                                        } else {
                                            errorMessage('Allowed only 500 characters')
                                        }
                                    }}
                                />
                            </Box>
                            <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mt={'0.5rem'}>
                                <Button variant='outlined'
                                    sx={{ height: '4.5dvh', mr: '1rem', textTransform: 'capitalize' }}
                                    onClick={() => {
                                        setLayout((prev) => ({
                                            ...prev,
                                            recallNotes: '',
                                            selectedOpto: null
                                        }))
                                    }}
                                >Clear</Button>
                                <Button variant='contained'
                                    sx={{ height: '4.5dvh', mr: '1rem', textTransform: 'capitalize' }}
                                    onClick={() => {
                                        if (layout.recallNotes === '') {
                                            errorMessage('Enter Recall Notes')
                                        } else if (layout.selectedOpto === null || layout.selectedOpto === '') {
                                            errorMessage('Select Opthometrist')
                                        } else {
                                            RecallNotesPost('pending')
                                        }
                                    }}
                                >Send</Button>
                            </Box>
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderPrimarydetails = () => {
        const { patientPrimType } = layout;
        return patientPrimType?.insurance_company_name
            ? renderCorpInsuranceCard("Insurance Details", patientPrimType.insurance_company_name)
            : patientPrimType?.employer_name
                ? renderCorpInsuranceCard("Corporate Details", patientPrimType.employer_name)
                : null;
    }

    return (
        <Box>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Box component={'div'} display={'flex'} alignItems={'center'}>
                    <Box component={'div'} className='doc_header_card' m={'0.5vw'}>
                        <CommonPatientDetails data={props?.patientData?.patient_details} showDetailed={true} fromDoctor={true} hideInsurance = {true}/>
                    </Box>
                    <Box component={'div'} display={'flex'} alignItems={'center'} mb={'0.5rem'}>
                        <Box component={'div'} className='doc_header_card'
                            sx={{ mr: '0.5rem', cursor: 'pointer', width: '5dvw', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                            onClick={() => { history?.push({ pathname: "/DoctorHome/Reports/DoctorVisit" }) }}
                        >
                            <Box component={'img'} src={ImagePaths.PreviousPrescription.default} height={'1.8vw'} width={'1.8vw'} />
                            <Typography fontSize={'0.8rem'} fontWeight={600}>Visit Log</Typography>
                        </Box>
                        {props?.patientData?.isOPT && props.patientData?.patient_details?.recall_status !== 'pending' ?
                            <Box component={'div'} className='doc_header_card'
                                sx={{ mr: '0.5rem', cursor: 'pointer', width: '5dvw', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                                onClick={() => { setLayout((prev) => ({ ...prev, recallPopup: true })) }}
                            >
                                <Box component={'img'} src={ImagePaths.SyncIcon.default} height={'1.8vw'} width={'1.8vw'} />
                                <Typography fontSize={'0.8rem'} fontWeight={600}>Recall</Typography>
                            </Box>
                            : !props.patientData?.isOPT && props.patientData?.patient_details?.recall_status === 'pending' ?
                                <Box component={'div'} onClick={() => { RecallNotesPost("completed") }}
                                    className='doc_header_card'
                                    sx={{ mr: '0.5rem', cursor: 'pointer', width: '5dvw', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} mr={'0.5vw'}>
                                    <Box component={'img'} src={ImagePaths.SyncCompleted.default} height={'1.8vw'} width={'1.8vw'} />
                                    <Typography fontSize={'0.8rem'} fontWeight={600}>Complete</Typography>
                                </Box> :
                                null}
                        {props?.patientData?.allergyData?.length > 0 ?
                            <Tooltip placement='top' title={props?.patientData?.allergyData?.map(item => item.allergy_name).join(",")} arrow>
                                <Box component={'div'} className='doc_header_card'
                                    sx={{ mr: '0.5rem', cursor: 'pointer', width: '5dvw', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Box component={'img'} src={ImagePaths.AllergyAlert.default} height={'1.8vw'} width={'1.8vw'} />
                                    <Typography fontSize={'0.8rem'} fontWeight={600}>Allergy</Typography>
                                </Box>
                            </Tooltip> : null}
                        {renderPrimarydetails()}
                    </Box>
                </Box>
                {props?.patientData?.isOPT ?
                    <Box component={'div'}>
                        <Button variant='contained' sx={{ mr: '0.5rem', textTransform: 'capitalize' }}
                            disabled={layout.isLocked || props?.patientData?.patient_transfered}
                            onClick={() => setLayout((prev) => ({
                                ...prev,
                                openTransferPopup: true,
                            }))}
                        >Transfer</Button>
                        {layout.isLocked || props?.patientData?.patient_transfered ?
                            <Button variant='contained' sx={{ mr: '0.5rem', textTransform: 'capitalize' }}
                                onClick={() => { setLayout((prev) => ({ ...prev, openAddendumPopup: true })) }}
                            >Addendum</Button> :
                            <Button variant='contained' sx={{ mr: '0.5rem', textTransform: 'capitalize' }}
                                onClick={() => { postLockDoctorNotes() }}
                            >Lock</Button>
                        }
                        <Button variant='contained' sx={{ mr: '0.5rem', textTransform: 'capitalize' }}
                            onClick={() => postStatusUpdate('Scan/Surgery')}
                            disabled={layout.isLocked || props?.patientData?.patient_transfered}
                        >Scan/Surgery</Button>
                        <Button variant='contained' sx={{ mr: '0.5rem', textTransform: 'capitalize' }}
                            onClick={() => setLayout((prev) => ({ ...prev, completePop: true }))}
                            disabled={layout.isLocked || props?.patientData?.patient_transfered || props?.patientData?.appointment_status === "Completed"}
                        >Complete</Button>
                    </Box> : null}
            </Box>
            {renderTransferPopupScreen()}
            {renderAddendumPopupScreen()}
            {renderRecallPopup()}
            {renderAddendumNotesPopupScreen()}
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {layout.completePop &&
                <ConfirmPopup
                    cnfTitle={'Confirmation'}
                    cnfContent={'Are you sure, Do you want to complete ?'}
                    cnfAlertPopupClose={() => { setLayout((prev) => ({ ...prev, completePop: false })) }}
                    cnfData={completeStatus.bind(this)}
                />}
                {console.log(props?.patientData)}
        </Box>
    )
})

export default UmaDocTopLayout